import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_get_sftp_configurationService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { application_name: string, instance: string }): Promise<{ Endpoint?: string, Port?: string, Username?: string, Password?: string, WorkingFolder?: string, ArchiveFolder?: string, ErrorFolder?: string, FileExtension?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.application_name)) {
      missingRequiredInParams.push('\'application_name\'');
    }
    if (isNil(inParams.instance)) {
      missingRequiredInParams.push('\'instance\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/get_sftp_configuration`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

